export default __webpack_public_path__ + "static/media/hawaiian.70e7bdf5.png";